import { render, staticRenderFns } from "./BuildPhaseData.vue?vue&type=template&id=4a45ba2e"
import script from "./BuildPhaseData.vue?vue&type=script&lang=ts"
export * from "./BuildPhaseData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports